// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ra-metrics {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
}
.ra-metric {
  display: flex;
  flex-direction: column;
  width: 33%;
  height: 160px;
  font-weight: 100
}
.ra-metric:last-child {
    width: 10%;
    max-width: 125px;
  }
.ra-metric__upper {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    flex-grow: 1;
    height: 55%;
  }
.ra-metric__upper-left {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 50px;
  }
.ra-metric__upper-left--icon {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #590b8a20;
      border: 2px solid #590b8a;
      border-radius: 10px;
      width: 50px;
      height: 50px;
    }
.ra-metric__upper-right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    flex-grow: 1;
    position: relative;
    padding-left: 8px;
    padding-right: 8px;
  }
.ra-metric__upper-right--stats {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      position: absolute;
      bottom: 35px;
    }
.ra-metric__upper-right--stats-self {
        font-size: clamp(1rem, 1.25vw, 1.5rem);
        color: #475467;
        margin-bottom: 4px;
        width: 100%
      }
.ra-metric__upper-right--stats-self.text-center {
          text-align: center;
        }
.ra-metric__upper-right--stats-market {
        font-size: clamp(1rem, 1.1vw, 1.5rem);
        color: #667085;
        margin-bottom: 4px
      }
.ra-metric__upper-right--stats-market.regular {
          color: red;
        }
.ra-metric__upper-right--stats-market.green {
          color: green;
        }
.ra-metric__upper-right--arrow-wrapper {
      position: relative;
      bottom: 17px;
      display: flex;
      width: 100%;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      /* padding-left: 5px;
      padding-right: 5px; */
    }
.ra-metric__lower {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 0.5vw;
    width: 100%;
    height: 45%;
  }
.ra-metric__lower--metric-name {
      font-size: clamp(1rem, 1.25vw, 1.5rem);
      width: 100%;
      color: #344054;
      margin-bottom: 2px;
    }
.ra-metric__lower--metric-value {
      width: 100%;
      font-size: clamp(1.5rem, 1.5vw, 24px);
      font-weight: 400;
    }

.line {
  border-bottom: 3px dashed #590b8a;
  width: 100%;
}

.arrow {
  width: 15px;
  height: 15px;
  position: relative;
}

.arrow::before {
  content: '';
  position: absolute;
  top: 2px;

  border-top: 3px solid #590b8a;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  vertical-align: top;
}

.arrow::after {
  content: '';
  position: absolute;
  top: 2px;
  border-bottom: 3px solid #590b8a;
  width: 10px;
  height: 10px;
  transform: rotate(-45deg);
  vertical-align: top;
}

@media only screen and (min-width: 1500px) {
    .ra-metric:last-child {
      width: 15%;
      max-width: 150px;
    }
}
@media only screen and (min-width: 1200px) {
    .ra-metric:last-child {
      width: 15%;
      max-width: 150px;
    }
}

@media only screen and (min-width: 1440px) {
  .ra-metric {
    height: 180px;
  }

  .ra-metric__upper-right--stats-self {
    font-size: clamp(1rem, 1.25vw, 1.5rem);
  }

  .ra-metric__upper-right--stats-market {
    font-size: clamp(1rem, 1.25vw, 24px);
  }

  .ra-metric__lower--metric-name {
    margin-bottom: 4px;
    font-size: clamp(1rem, 1.25vw, 24px);
  }

  .ra-metric__lower--metric-value {
    font-size: clamp(1.5rem, 1.3vw, 2.5rem);
  }
}

@media only screen and (min-width: 2200px) {
  .ra-metric {
    height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RaMetrics.pcss"],"names":[],"mappings":"AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb;AAuGF;AArGE;IACE,UAAU;IACV,gBAAgB;EAClB;AAEA;IACE,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,WAAW;EACb;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;EAWb;AAVE;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,2BAA2B;MAC3B,yBAAyB;MACzB,mBAAmB;MACnB,WAAW;MACX,YAAY;IACd;AAGF;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EAyCpB;AAxCE;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;MACX,kBAAkB;MAClB,YAAY;IAqBd;AApBE;QACE,sCAAsC;QACtC,cAAc;QACd,kBAAkB;QAClB;MAIF;AAHE;UACE,kBAAkB;QACpB;AAEF;QACE,qCAAqC;QACrC,cAAc;QACd;MAOF;AANE;UACE,UAAU;QACZ;AACA;UACE,YAAY;QACd;AAGJ;MACE,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,WAAW;MACX,mBAAmB;MACnB,iBAAiB;MACjB,uBAAuB;MACvB,mBAAmB;MACnB;2BACqB;IACvB;AAGF;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;IACX,WAAW;EAYb;AAXE;MACE,sCAAsC;MACtC,WAAW;MACX,cAAc;MACd,kBAAkB;IACpB;AACA;MACE,WAAW;MACX,qCAAqC;MACrC,gBAAgB;IAClB;;AAIJ;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;;EAER,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;IAEI;MACE,UAAU;MACV,gBAAgB;IAClB;AAEJ;AACA;IAEI;MACE,UAAU;MACV,gBAAgB;IAClB;AAEJ;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["$ultraLargeDesktop: 1500px;\n$largeDesktop: 1200px;\n$midDesktop: 1000px;\n$smallDesktop: 750px;\n\n#ra-metrics {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  width: 100%;\n  padding-top: 10px;\n}\n.ra-metric {\n  display: flex;\n  flex-direction: column;\n  width: 33%;\n  height: 160px;\n  font-weight: 100;\n\n  &:last-child {\n    width: 10%;\n    max-width: 125px;\n  }\n\n  &__upper {\n    display: flex;\n    flex-wrap: nowrap;\n    width: 100%;\n    flex-grow: 1;\n    height: 55%;\n  }\n\n  &__upper-left {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    width: 50px;\n    &--icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: #590b8a20;\n      border: 2px solid #590b8a;\n      border-radius: 10px;\n      width: 50px;\n      height: 50px;\n    }\n  }\n\n  &__upper-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-end;\n    flex-grow: 1;\n    position: relative;\n    padding-left: 8px;\n    padding-right: 8px;\n    &--stats {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      width: 100%;\n      position: absolute;\n      bottom: 35px;\n      &-self {\n        font-size: clamp(1rem, 1.25vw, 1.5rem);\n        color: #475467;\n        margin-bottom: 4px;\n        width: 100%;\n        &.text-center {\n          text-align: center;\n        }\n      }\n      &-market {\n        font-size: clamp(1rem, 1.1vw, 1.5rem);\n        color: #667085;\n        margin-bottom: 4px;\n        &.regular {\n          color: red;\n        }\n        &.green {\n          color: green;\n        }\n      }\n    }\n    &--arrow-wrapper {\n      position: relative;\n      bottom: 17px;\n      display: flex;\n      width: 100%;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: center;\n      align-items: center;\n      /* padding-left: 5px;\n      padding-right: 5px; */\n    }\n  }\n\n  &__lower {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-top: 0.5vw;\n    width: 100%;\n    height: 45%;\n    &--metric-name {\n      font-size: clamp(1rem, 1.25vw, 1.5rem);\n      width: 100%;\n      color: #344054;\n      margin-bottom: 2px;\n    }\n    &--metric-value {\n      width: 100%;\n      font-size: clamp(1.5rem, 1.5vw, 24px);\n      font-weight: 400;\n    }\n  }\n}\n\n.line {\n  border-bottom: 3px dashed #590b8a;\n  width: 100%;\n}\n\n.arrow {\n  width: 15px;\n  height: 15px;\n  position: relative;\n}\n\n.arrow::before {\n  content: '';\n  position: absolute;\n  top: 2px;\n\n  border-top: 3px solid #590b8a;\n  width: 10px;\n  height: 10px;\n  transform: rotate(45deg);\n  vertical-align: top;\n}\n\n.arrow::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  border-bottom: 3px solid #590b8a;\n  width: 10px;\n  height: 10px;\n  transform: rotate(-45deg);\n  vertical-align: top;\n}\n\n@media only screen and (min-width: 1500px) {\n  .ra-metric {\n    &:last-child {\n      width: 15%;\n      max-width: 150px;\n    }\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .ra-metric {\n    &:last-child {\n      width: 15%;\n      max-width: 150px;\n    }\n  }\n}\n\n@media only screen and (min-width: 1440px) {\n  .ra-metric {\n    height: 180px;\n  }\n\n  .ra-metric__upper-right--stats-self {\n    font-size: clamp(1rem, 1.25vw, 1.5rem);\n  }\n\n  .ra-metric__upper-right--stats-market {\n    font-size: clamp(1rem, 1.25vw, 24px);\n  }\n\n  .ra-metric__lower--metric-name {\n    margin-bottom: 4px;\n    font-size: clamp(1rem, 1.25vw, 24px);\n  }\n\n  .ra-metric__lower--metric-value {\n    font-size: clamp(1.5rem, 1.3vw, 2.5rem);\n  }\n}\n\n@media only screen and (min-width: 2200px) {\n  .ra-metric {\n    height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
